import Loader from "react-loader-spinner";
import styled from "styled-components";
import theme from "../theme/theme";
import GoalIcon from "./GoalIcon";

const Wrapper = styled.button`
  border-radius: 15px;
  padding: 3rem 50px;
  text-decoration: none;
  background-color: ${theme.colors.white};
  border: none;
  transition: transform 0.2s;
  width: 320px;
  height: 350px;
  box-sizing: border-box;

  &[disabled] {
    pointer-events: none;
  }

  &.loading {
    .goal {
      display: none;
    }
    .spinner {
      display: block;
    }
  }

  &:hover,
  &.loading {
    box-shadow: 0px 3px 6px #00000029;
    background-color: #fafeff;
    cursor: pointer;
    transform: translateY(-5px);
  }

  > * {
    pointer-events: none;
  }

  .goal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .spinner {
    display: none;
  }

  .icon {
    display: flex;
    place-items: center;
  }

  .type,
  .desc {
    color: ${theme.colors.black};
    text-align: center;
  }

  .type {
    font-size: 1.5em;
    line-height: 1.25;
    margin-top: 40px;
    margin-bottom: 15px;
  }

  .desc {
    font-size: 14px;
    line-height: 18px;
    color: ${theme.colors.gray1};
  }

  @media (max-width: 1075px) {
    width: 100%;
  }
`;

const GoalContainer = ({ type, path, desc, disabled, handleClick }) => {
  return (
    <Wrapper
      data-goal-path={path}
      data-goal-type={type}
      onClick={handleClick}
      disabled={disabled}
    >
      <div className="goal">
        <div className="icon">
          <GoalIcon type={type} />
        </div>
        <span className="type">{type}</span>
        <span className="desc">{desc}</span>
      </div>
      <div className="spinner">
        <Loader type="Puff" color="#00BFFF" height={80} width={80} />
      </div>
    </Wrapper>
  );
};

export default GoalContainer;
